import { render, staticRenderFns } from "./Budgets.vue?vue&type=template&id=2ff6a12e&scoped=true"
import script from "./Budgets.vue?vue&type=script&lang=js"
export * from "./Budgets.vue?vue&type=script&lang=js"
import style0 from "./Budgets.vue?vue&type=style&index=0&id=2ff6a12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff6a12e",
  null
  
)

export default component.exports